import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

interface DrawerScrollBodyProps {
  children: ReactNode;
  /** Extra styles merged onto the scroll container (padding, bgcolor, …). */
  sx?: SxProps<Theme>;
}

/**
 * Flex-growing, vertically scrollable drawer body with the shared themed
 * scrollbar (uses the `--scrollbar-width` / `--gray-*` tokens from the drawer
 * shell). Callers add their own padding / background via `sx`.
 */
export function DrawerScrollBody({ children, sx }: DrawerScrollBodyProps) {
  return (
    <Box
      sx={[
        {
          flex: 1,
          overflowY: 'auto',
          '&::-webkit-scrollbar': { width: 'var(--scrollbar-width)' },
          '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
          '&::-webkit-scrollbar-thumb': { bgcolor: 'var(--gray-300)', borderRadius: 3 },
          '&::-webkit-scrollbar-thumb:hover': { bgcolor: 'var(--gray-400)' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
